
import "../Styles/Logo.css"
// import React from "react";
// import "./Logo.css";
import React from "react";
// import "./Logo.css";

const Logo = () => {
  return (
    <div className="logo-container">
      <svg
        viewBox="0 0 200 200"
        className="logo-svg"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Crisscrossing Paths */}
        <path
          d="M 50,100 C 80,20 120,20 150,100 S 120,180 100,100"
          stroke="url(#gradient1)"
          strokeWidth="10"
          fill="none"
          className="animated-path"
        />
        <path
          d="M 100,50 C 180,80 180,120 100,150 S 20,120 100,100"
          stroke="url(#gradient2)"
          strokeWidth="10"
          fill="none"
          className="animated-path"
        />
        <path
          d="M 50,100 C 20,120 80,180 100,100 S 180,80 150,100"
          stroke="url(#gradient3)"
          strokeWidth="10"
          fill="none"
          className="animated-path"
        />

        {/* Gradient definitions for smooth flowing color */}
        <defs>
          <linearGradient id="gradient1" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="red">
              <animate
                attributeName="offset"
                values="0;1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="blue">
              <animate
                attributeName="offset"
                values="1;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>

          <linearGradient id="gradient2" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="blue">
              <animate
                attributeName="offset"
                values="0;1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="green">
              <animate
                attributeName="offset"
                values="1;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>

          <linearGradient id="gradient3" gradientTransform="rotate(90)">
            <stop offset="0%" stopColor="green">
              <animate
                attributeName="offset"
                values="0;1"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="red">
              <animate
                attributeName="offset"
                values="1;0"
                dur="3s"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      </svg>

      {/* FusionXe Text in the center */}
      <div className="logo-text">FusionXe</div>
    </div>
  );
};

export default Logo;
